import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { FormField } from '../../../common/models/form-details.model';
import { WS10HeadlineModel, HeadlineTagEnum } from '@vfde-fe/ngx-lib/brix/ws10-headline';
import { FORM_FIELD_TYPE } from '../../../shared/defines/defines';
/** HeadlineComponent */
@Component({
  selector: 'app-headline',
  templateUrl: './headline.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./headline.component.scss'],
})
export class HeadlineComponent implements OnInit {

  /** headlineConfig */
  public headlineConfig: WS10HeadlineModel;

  /** formField */
  @Input() public formField: FormField;

  /** headingSize */
  public headingSize: HeadlineTagEnum;

  /** ngOnInit */
  public ngOnInit (): void {
    if (this.formField) {
      this.setHeadingSize(this.formField.type);
      this.configureComponent(this.formField);
    }
  }
  /** setHeadingSize
   * @method setHeadingSize
   * @param {string} type
   */
   public setHeadingSize (type: string) {
    switch (type) {
      case FORM_FIELD_TYPE.HEADLINE:
        this.headingSize = HeadlineTagEnum.H2;
        break;
      case FORM_FIELD_TYPE.SUBHEADLINE:
        this.headingSize = HeadlineTagEnum.H4;
        break;
    }
  }
  /** configureComponent
   * @method configureComponent
   * @param {FormField} data
   */
   public configureComponent (data: FormField) {
    if (data && data.value && this.headingSize) {
      this.headlineConfig = {
        headingSize: this.headingSize,
        textContent: data.value,
      };
    }
  }
}
